/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Ateliere_Connect_Status_Importing_CaptionInputs */



/**
* | output |
* | --- |
* | "Importing caption file: {name}..." |
*
* @param {Ateliere_Connect_Status_Importing_CaptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_importing_caption = /** @type {((inputs: Ateliere_Connect_Status_Importing_CaptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Importing_CaptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Importation du fichier de sous-titres : ${i?.name}...`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Importiere Untertiteldatei: ${i?.name}...`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Importazione del file didascalia: ${i?.name}...`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Импорт файла субтитров: ${i?.name}...`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Importando archivo de subtítulos: ${i?.name}...`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在导入字幕文件：${i?.name}...`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`キャプションファイルをインポートしています: ${i?.name}...`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`कैप्शन फ़ाइल आयात की जा रही है: ${i?.name}...`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Importando arquivo de legenda: ${i?.name}...`)
	return /** @type {LocalizedString} */ (`Importing caption file: ${i?.name}...`)
});